// ABOUTME: While the chat is open and the tab visible, tell the API so the dispatcher that hands
// messages to the agent is already running when the owner sends one (app/api/v1/agent/chat.py
// `/chat/ready`); repeated inside the dispatcher's idle window.

import { useEffect } from 'react'
import { readyChat } from '@/api/agent'

// Under the dispatcher's 300 s idle exit (app/workers/dispatcher_run.py).
const READY_EVERY_MS = 4 * 60 * 1000

export function useChatReady() {
  useEffect(() => {
    const ping = () => {
      if (document.visibilityState === 'visible') void readyChat().catch(() => undefined)
    }
    ping()
    const timer = setInterval(ping, READY_EVERY_MS)
    document.addEventListener('visibilitychange', ping)
    return () => {
      clearInterval(timer)
      document.removeEventListener('visibilitychange', ping)
    }
  }, [])
}
